import { ZoneSamplingCondition } from '../../domain/zone-sampling-condition';
import { mapper } from '../../tools/mapping/mapper';
import { ZoneSamplingConditionEntity } from '../entity';
import type { AppDB } from '../db';

export class ZoneSamplingConditionRepository {
    constructor(private readonly database: AppDB) {}


    async getSamplingConditionEntityById(id: number) {
        return await this.database.zoneSamplingConditions.where('Id').equals(id).first(async sce => {
            return sce;
        });
    }

    async attachSamplingCondition(condition: ZoneSamplingCondition, measureId: number) {
        let sampCondId: number;
        const sampCond = mapper.map(condition, ZoneSamplingCondition, ZoneSamplingConditionEntity);

        sampCondId = await this.database.zoneSamplingConditions.add(sampCond);
        await this.database.mesures.update(measureId, {
            SamplingConditionId: sampCondId
        });
        return sampCondId;
    }
}
